import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function PageShell({ title, children, testId }) {
  useEffect(() => {
    if (title) document.title = `${title} · Dishly`;
    window.scrollTo(0, 0);
  }, [title]);
  return (
    <div className="min-h-screen bg-cream text-charcoal" data-testid={testId}>
      <Header />
      <main className="pt-28 pb-20">{children}</main>
      <Footer />
    </div>
  );
}
